import templates from './templates';
import './index.styl';
import { CoreRegenerationInviteView } from '../../../../../core/views';
import { redirectTo } from '../../../utils';

/**
 *
 */
export default  class RegenerationCompInviteView extends CoreRegenerationInviteView {
	getTemplate() {
		let count_users = this.model.get( 'num_teams' );

		if ( count_users < 20 ) {
			return templates.invite;
		}
		else {
			return templates.invite_all;
		}
	}

	sendEmailInvites() {
		let data = {
			comp_id: this.model.get( 'id' ),
			invites:   this.emailLists
		};

		this.model.sendInvites( data );
	}

	sendInvitesSuccess() {
		let url = `comps/${this.league_id}/regenerate/congratulation`;
		redirectTo( url );
	}
}